import { TASK_STATUS } from 'constants/interfaces';
import { TASK_PRIORITY_OPTIONS } from 'constants/taskPriority';

import type { TTaskStatus } from 'constants/interfaces';

export const getPriorityIcon = (priority: string) => {
  const priorityOption = TASK_PRIORITY_OPTIONS.find(
    (option) => option.label?.toLowerCase() === priority.toLowerCase(),
  );
  return priorityOption?.icon;
};

export const getFileExtension = (url: string): string => {
  const lastDotIndex = url.lastIndexOf('.');
  const lastSlashIndex = url.lastIndexOf('/');

  if (lastDotIndex > lastSlashIndex && lastDotIndex !== -1) {
    return url.substring(lastDotIndex);
  }
  return '';
};

export const getFileNameWithExtension = (name: string, url: string): string => {
  const extension = getFileExtension(url);
  if (extension && !name.toLowerCase().endsWith(extension.toLowerCase())) {
    return `${name}${extension}`;
  }
  return name;
};

export const getStatusClassName = (status: TTaskStatus, styles: Record<string, string>) => {
  const statusMap: Record<TTaskStatus, string> = {
    [TASK_STATUS.created]: styles.itemCreated,
    [TASK_STATUS.assigned]: styles.itemAssigned,
    [TASK_STATUS.inProgress]: styles.itemInProgress,
    [TASK_STATUS.completed]: styles.itemCompleted,
    [TASK_STATUS.deferred]: styles.itemDeferred,
    [TASK_STATUS.blocked]: styles.itemBlocked,
    [TASK_STATUS.cancelled]: styles.itemCancelled,
  };
  return statusMap[status] || styles.itemCreated;
};

export const getUserInitials = (name: string): string => name
  .split(' ')
  .map((part) => part.charAt(0).toUpperCase())
  .join('')
  .slice(0, 2);
